/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { React, useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDAppBar from "components/MDAppBar";

// Settings page components
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Header from "layouts/account/components/Header";
import BasicInfo from "layouts/account/components/BasicInfo";
// import CustomApp from "layouts/account/components/CustomApp";
// import CustomWelcomeAppMobile from "layouts/account/components/CustomWelcomeAppMobile";
import ChangePassword from "layouts/account/components/ChangePassword";
import Notifications from "layouts/account/components/Notifications";
import LogoutAccount from "layouts/account/components/LogoutAccount";
import { sendGetProjectManagers } from "store/actions/projectManagersActions";

import { useTranslation } from "react-i18next";
import ProjectManagers from "./components/ProjectManagers/ProjectManagers";
import CustomProjectMenu from "./components/CustomProjectMenu";

function Settings({ database, user, actGetProjectManagers }) {
  const { t } = useTranslation();

  const { isProjectManager } = user;
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    actGetProjectManagers();
  }, []);

  const tabConfig = [
    !isProjectManager && {
      key: "basicInfo",
      icon: "badge",
      label: t("Basic Info"),
      component: <BasicInfo user={user} database={database} />,
    },
    !isProjectManager && {
      key: "projectManagers",
      icon: "group",
      label: t("Project Managers"),
      component: <ProjectManagers user={user} database={database} />,
    },
    !isProjectManager && {
      key: "customProjectMenu",
      icon: "view_list",
      label: t("Custom Project Menu"),
      component: <CustomProjectMenu user={user} database={database} />,
    },
    !isProjectManager && {
      key: "changePassword",
      icon: "lock",
      label: t("Change Password"),
      component: <ChangePassword />,
    },
    !isProjectManager && {
      key: "notifications",
      icon: "notifications",
      label: t("Notifications"),
      component: <Notifications user={user} database={database} />,
    },
  ].filter(Boolean);

  useEffect(() => {
    if (tabValue >= tabConfig.length) {
      setTabValue(0);
    }
  }, [tabConfig.length, tabValue]);

  const tabsInfo = tabConfig.map((tab) => ({
    label: tab.label,
    icon: tab.icon,
  }));

  return (
    <DashboardLayout>
      <DashboardNavbar title={t("account")} route="/account" />
      <MDBox mt={5}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12 }}>
            <Header
              t={t}
              user={user}
              rightContent={
                <Grid container justifyContent={{ xs: "center", md: "flex-end" }}>
                  <LogoutAccount />
                </Grid>
              }
            />
          </Grid>
        </Grid>
      </MDBox>
      <MDBox mt={3}>
        {!isProjectManager && (
          <MDAppBar tabsInfo={tabsInfo} tabValue={tabValue} setTabValue={setTabValue} />
        )}
      </MDBox>
      <MDBox mt={2}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12 }}>
            <MDBox mb={3}>
              <Grid container spacing={3}>
                <Grid size={{ xs: 12 }}>{tabConfig[tabValue]?.component}</Grid>
              </Grid>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

Settings.defaultProps = {
  user: {
    uid: "",
  },
};

Settings.propTypes = {
  user: PropTypes.object,
  database: PropTypes.object.isRequired,
  actGetProjectManagers: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  actGetProjectManagers: () => dispatch(sendGetProjectManagers()),
});

const mapStateToProps = (state) => ({
  initialValues: state.mainUserReducer,
  user: state.mainUserReducer,
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
